module.exports = __webpack_public_path__ + "static/img/deepseek-tag.2f92d806.png";